import { defineMessages } from 'react-intl';

const scope = 'dashboard.newsletter';

const messages = defineMessages({
  exportButton: {
    id: `${scope}.ExportButton`,
    defaultMessage: '내보내기',
  },
  expandedPDFViewerCanvas: {
    id: `${scope}.ExpandedPDFViewer.canvas`,
    defaultMessage: '현재 사용 중인 브라우저에서 지원하지 않는 기능입니다. 다른 브라우저를 이용해주세요.',
  },
  expandedPdfViewerPageNumber: {
    id: `${scope}.ExpandedPDFViewer.PageNumber`,
    defaultMessage: '{ page } 페이지',
  },
  individualViewportFooterPageNumber: {
    id: `${scope}.IndividualViewportFooter.PageNumber`,
    defaultMessage: '{ page } 페이지',
  },
  individualParagraphNoResponse: {
    id: `${scope}.Individual.Paragraph.noResponse`,
    defaultMessage: '응답을 기다리는 중입니다.',
  },
  printButton: {
    id: `${scope}.PrintButton`,
    defaultMessage: '인쇄하기',
  },
  newsletterHeading: {
    id: `${scope}.Newsletter.Heading`,
    defaultMessage: '가정통신문 상세',
  },
  newsletterLinkStats: {
    id: `${scope}.Newsletter.Link.stats`,
    defaultMessage: '통계',
  },
  newsletterLinkIndividual: {
    id: `${scope}.Newsletter.Link.individual`,
    defaultMessage: '개별 응답',
  },
  newsletterStatusMarkOngoing: {
    id: `${scope}.Newsletter.StatusMark.ongoing`,
    defaultMessage: '응답 중',
  },
  newsletterStatusMarkClosed: {
    id: `${scope}.Newsletter.StatusMark.closed`,
    defaultMessage: '종료',
  },
  singleSelectionQuestionNoContent: {
    id: `${scope}.SingleSelectionQuestion.noContent`,
    defaultMessage: '질문 { number }',
  },
  multipleSelectionQuestionNoContent: {
    id: `${scope}.MultipleSelectionQuestion.noContent`,
    defaultMessage: '질문 { number }',
  },
  descriptiveQuestionNoContent: {
    id: `${scope}.DescriptiveQuestion.noContent`,
    defaultMessage: '질문 { number }',
  },
  statsParagraphNoQuestion: {
    id: `${scope}.Stats.Paragraph.noQuestion`,
    defaultMessage: '문항이 없는 가정통신문입니다.',
  },
  statsParagraphNoResponse: {
    id: `${scope}.Stats.Paragraph.noResponse`,
    defaultMessage: '응답을 기다리는 중입니다.',
  },
  statsViewportCanvas: {
    id: `${scope}.StatsViewport.canvas`,
    defaultMessage: '현재 사용 중인 브라우저에서 지원하지 않는 기능입니다. 다른 브라우저를 이용해주세요.',
  },
  statsViewportFooterPageNumber: {
    id: `${scope}.StatsViewportFooter.PageNumber`,
    defaultMessage: '{ page } 페이지',
  },
  statsViewportFooterTooltipVisibility: {
    id: `${scope}.StatsViewportFooter.Tooltip.Visibility`,
    defaultMessage: '문항 표시',
  },
  statsViewportFooterTooltipVisibilityOff: {
    id: `${scope}.StatsViewportFooter.Tooltip.VisibilityOff`,
    defaultMessage: '문항 숨김',
  },
  statsViewportFooterTooltipZoomOutMap: {
    id: `${scope}.StatsViewportFooter.Tooltip.ZoomOutMap`,
    defaultMessage: '크게 보기',
  },
  statusSwitcherLabelOngoing: {
    id: `${scope}.StatusSwitcher.label.ongoing`,
    defaultMessage: '응답 중',
  },
  statusSwitcherLabelClosed: {
    id: `${scope}.StatusSwitcher.label.closed`,
    defaultMessage: '응답 종료',
  },
});

export default messages;
